import React, { useState, useEffect} from 'react';
import cmsUtils from '../../utils/cmsUtils';
import utils from '../../../utils';
import { SiteLink } from '../../../components';

export function BannerItem(props) {
  const item = props.item;
  const cmsOption = props.cmsOption || {};
  const [isMobile, setIsMobile] = useState(utils.site.isMobile());

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(utils.site.isMobile());
    };

    window.addEventListener('resize', handleResize);
    
    // Cleanup function to remove event listener
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  //console.log('item', item);

  const bgUrl = utils.site.resourcePath(cmsUtils.payload(item, 'ImageUrl'));
  let bgUrlMobile = utils.site.resourcePath(cmsUtils.payload(item, 'ImageUrl2'));

  if (!bgUrlMobile) {
    bgUrlMobile = bgUrl;
  }

  const alignV = cmsUtils.payload(item, 'VAlign') || '50%';
  const alignVMobile = cmsUtils.payload(item, "VAlign2") || "50%";

  const captionTitle = cmsUtils.payload(item, 'CaptionTitle2') || cmsUtils.payload(item, 'CaptionTitle');
  const captionButton = cmsUtils.payload(item, 'CaptionButton') && cmsUtils.payload(item, 'CaptionButton') !== "" ? cmsUtils.payload(item, 'CaptionButton') : "READ MORE";
  
  const linkUrl = cmsUtils.payload(item, 'LinkUrl2') || cmsUtils.payload(item, 'LinkUrl');

  const overlayOpacityPayload = cmsUtils.payload(item, 'OverlayOpacity');
  const overlayOpacityPayloadMobile = cmsUtils.payload(item, 'OverlayOpacity2');

  const overlayOpacity = (() => {
    if (overlayOpacityPayload === undefined || overlayOpacityPayload === null || overlayOpacityPayload === '') {
      return undefined;
    }
    const rawValue = `${isMobile ? overlayOpacityPayloadMobile : overlayOpacityPayload}`.trim();
    const isPercentValue = rawValue.endsWith('%');
    const parsedValue = parseFloat(rawValue);
    if (Number.isNaN(parsedValue)) {
      return undefined;
    }
    const normalizedValue = isPercentValue || parsedValue > 1 ? parsedValue / 100 : parsedValue;
    return Math.min(1, Math.max(0, normalizedValue));
  })();

  const titlePanel = captionTitle ? (
    linkUrl ? (<div>
      <div className="banner-item__title" dangerouslySetInnerHTML={{ __html: captionTitle }}></div>
      <SiteLink to={linkUrl} className="banner-item__link"> { captionButton } </SiteLink>
    </div>
    ) : (<div className="banner-item__title" dangerouslySetInnerHTML={{ __html: captionTitle }}></div>)
  ) : null;

  const linkOverlay = linkUrl && !captionTitle ? (
    <SiteLink className="bannerItem__overlay" to={linkUrl}></SiteLink>
  ) : null;

  const cssClass = utils.classNames('cms_item', 'banner-item', 'bannerSize', item.cssClass || item.anchorName || '', titlePanel && 'bannerHasTitlePanel');

  const bannerStyles = {
    backgroundImage: utils.css.bgUrlStyle(isMobile ? bgUrlMobile : bgUrl),
    backgroundPositionY: isMobile ? alignVMobile : alignV,
    ...(overlayOpacity !== undefined ? { '--banner-overlay-opacity': overlayOpacity } : {})
  };

  return (
    <div className={cssClass} data-cms-item-id={cmsOption.isCmsEdit && item.itemId} id={item.anchorName}
      style={bannerStyles}>
      {titlePanel && <div className="banner_item__text">{titlePanel}</div>}
      {linkOverlay && linkOverlay}
    </div>
  );


}
